import React, { Component } from "react";
import { Button, Col, Form, Image } from "react-bootstrap";
import Desplegable from "../../desplegable";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class FormDatosPersonales extends Component {
  constructor(props) {
    super(props);
    //Una variable controla si esta relleno o no el campo de los pdf
    //La otra controla si el campo esta vacio porque ha sido eliminado o porque el usuairo no ha metido ese pdf
    this.state = {
      drivingLicense: false,
      addDrivingLicense: true,
      passport: false,
      addPassPort: true,
      photo: false,
      addPhoto: true,
      cv: false,
      addcv: true,
      active: 0
    };
    this.DatosPersonalesPut = this.DatosPersonalesPut.bind(this);
  }

  componentDidMount() {
    //es el useEffect de la nueva era react
    //console.log(this.props.DatosUsuario)
    let drivingLicense = !!this.props.DatosUsuario.drivingLicense;
    let passport = !!this.props.DatosUsuario.passportDocument;
    let photo =
      this.props.DatosUsuario.photo !== "/images/nun.png" &&
      this.props.DatosUsuario.photo !== "/images/laico1.png" &&
      this.props.DatosUsuario.photo !== "/images/laico2.png" &&
      this.props.DatosUsuario.photo;
    let cv = !!this.props.DatosUsuario.cv;

    this.setState({
      drivingLicense: drivingLicense,
      passport: passport,
      photo: photo,
      cv: cv,
      active: !this.props.DatosUsuario.active,
      laico: this.props.DatosUsuario.type === 'Laico' ? 1 : 0
    });
  }

  changeAddDrivingLicense() {
    this.setState({
      addDrivingLicense: !this.state.addDrivingLicense,
    });
  }

  changeActive() {
    this.setState({
      active: !this.state.active,
    });
  }

  // Función que hace el put a los datos personales de la monja
  async DatosPersonalesPut(e) {
    e.preventDefault();
    let $this = $(this);
    //Formdata coge todo los elementos del formulario
    let myform = document.getElementById("MyForm");
    //console.log('las cosas del formulario')

    let form = new FormData(myform);
    //console.log(form)

    //Comprobamos si hemos añadido un documento de conducir y cambiamos el estado
    if (e.target["drivingLicense"]) {
      if (e.target["drivingLicense"].value) {
        $this[0].setState({
          drivingLicense: true,
        });
      }
    }

    //Comprobamos si hemos añadido un pasaporte y cambiamos el estado
    if (e.target["passportDocument"]) {
      if (e.target["passportDocument"].value) {
        $this[0].setState({
          passport: true,
        });
      }
    }

    if (e.target["photo"]) {
      if (e.target["photo"].value) {
        $this[0].setState({
          photo: true,
        });
      }
    }

    if (e.target["cv"]) {
      if (e.target["cv"].value) {
        $this[0].setState({
          cv: true,
        });
      }
    }
    //console.log('wwwwwwwww')
    //e.target["active"]='ddd'
    //console.log(e.target["active"])

    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id,
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito los asigna al estado del componente monja detalle
    await $.ajax(settings)
      .done(async function (response) {
        response = JSON.parse(response);
        $this[0].props.setDatosPersonales(response);
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");

        //Eliminamos el pdf en funcion del estado del componente tambien comprobamos que sea pq se haya eliminado el pdf y no añadido
        if (!$this[0].state.drivingLicense && !$this[0].state.addDrivingLicense) {
          await utils.callAjaxGet("DELETE", process.env.REACT_APP_API_URL + "/download/usuarios/" + $this[0].props.DatosUsuario.id + "/carnetConducir", $this[0].props.ErrorHandling);
          $this[0].props.nullField("drivingLicense", null);
        }
        //Eliminamos el pdf en funcion del estado del componente
        if (!$this[0].state.passport && !$this[0].state.addPassPort) {
          await utils.callAjaxGet("DELETE", process.env.REACT_APP_API_URL + "/download/usuarios/" + $this[0].props.DatosUsuario.id + "/pasaporte", $this[0].props.ErrorHandling);

          $this[0].props.nullField("passportDocument", null);
        }

        if (!$this[0].state.photo && !$this[0].state.addPhoto) {
          await utils.callAjaxGet("DELETE", process.env.REACT_APP_API_URL + "/download/usuarios/" + $this[0].props.DatosUsuario.id, $this[0].props.ErrorHandling);
          $this[0].props.nullField("photo", "photo");
        }
        if (!$this[0].state.cv && !$this[0].state.addcv) {
          await utils.callAjaxGet("DELETE", process.env.REACT_APP_API_URL + "/download/usuarios/" + $this[0].props.DatosUsuario.id + "/cv", $this[0].props.ErrorHandling);
          $this[0].props.nullField("cv", null);
        }

        // Por si se ejecuta varias veces el eliminar un documento y guardar
        $this[0].setState({
          addDrivingLicense: true,
          addPassPort: true,
          addcv: true,
          addPhoto: true,
        });
      })

      .fail(function (e) {
        //console.log(JSON.parse(e.responseText).errors[0].msg);
        $this[0].props.setAlert("", JSON.parse(e.responseText)?.errors[0]?.msg, "warning");
      }

      )


  }

  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();
    const photo = this.state.photo ? (
      <Form.Group>
        <a href={process.env.REACT_APP_API_URL + "/download/usuarios/" + this.props.DatosUsuario.id} target="_blank" rel="noreferrer">
          Foto
        </a>
        <Button
          variant="light"
          className="ml-3"
          onClick={() =>
            this.setState({
              photo: false,
              addPhoto: false,
            })
          }
        >
          <Image width="25" fluid src={"/svg/trash-outline.svg"}></Image>
        </Button>
      </Form.Group>
    ) : (
      <Form.Group>
        <Form.Label>Fotografía <small>(máx. 500KB)</small></Form.Label>
        <Form.Control type="file" name="photo" />
      </Form.Group>
    );

    const carnetConducir = this.state.drivingLicense ? (
      <Form.Group>
        <a href={process.env.REACT_APP_API_URL + "/download/usuarios/" + this.props.DatosUsuario.id + "/carnetConducir"} target="_blank" rel="noreferrer">
          Ver Carnet de conducir
        </a>
        <Button
          variant="light"
          className="ml-3"
          onClick={() =>
            this.setState({
              drivingLicense: false,
              addDrivingLicense: false,
            })
          }
        >
          <Image width="25" fluid src={"/svg/trash-outline.svg"}></Image>
        </Button>
      </Form.Group>
    ) : (
      <>
        <label>
          <input type="checkbox" checked={this.state.addDrivingLicense} onChange={() => this.changeAddDrivingLicense()} /> Carnet de conducir <small>(máx. 500KB)</small>
        </label>
        {
          // renderizado condicional del form del carnet de conducir
          this.state.addDrivingLicense && (
            <Form.Group>
              <Form.Label>Carnet de Conducir</Form.Label>
              <Form.Control type="file" name="drivingLicense" />
            </Form.Group>
          )
        }
      </>
    );

    const passport = this.state.passport ? (
      <Form.Group>
        <a href={process.env.REACT_APP_API_URL + "/download/usuarios/" + this.props.DatosUsuario.id + "/pasaporte"} target="_blank" rel="noreferrer">
          Ver Pasaporte
        </a>
        <Button
          variant="light"
          className="ml-3"
          onClick={() =>
            this.setState({
              passport: false,
              addPassPort: false,
            })
          }
        >
          <Image width="25" fluid src={"/svg/trash-outline.svg"}></Image>
        </Button>
      </Form.Group>
    ) : (
      <Form.Group>
        <Form.Label>Archivo Pasaporte <small>(máx. 500KB)</small></Form.Label>
        <Form.Control type="file" name="passportDocument" />
      </Form.Group>
    );

    const cv =
      this.props.DatosUsuario.sister === null || !this.props.DatosUsuario.sister ? (
        this.state.cv ? (
          <Form.Group>
            <a href={process.env.REACT_APP_API_URL + "/download/usuarios/" + this.props.DatosUsuario.id + "/cv"} target="_blank" rel="noreferrer">
              Curriculum
            </a>
            <Button
              variant="light"
              className="ml-3"
              onClick={() =>
                this.setState({
                  cv: false,
                  addcv: false,
                })
              }
            >
              <Image width="25" fluid src={"/svg/trash-outline.svg"}></Image>
            </Button>
          </Form.Group>
        ) : (
          <Form.Group>
            <Form.Label>Curriculum</Form.Label>
            <Form.Control type="file" name="cv" />
          </Form.Group>
        )
      ) : null;

    let genderInput =
      this.props.DatosUsuario.type === "Laico" ? (
        <Form.Group>
          <Form.Label>Sexo *</Form.Label>
          <Form.Check type="radio" label="Mujer" value="m" name="gender" defaultChecked={this.props.DatosUsuario.gender === "m" ? 1 : 0} />
          <Form.Check type="radio" label="Hombre" name="gender" value="h" defaultChecked={this.props.DatosUsuario.gender === "h" ? 1 : 0} />
        </Form.Group>
      ) : null;

    const esMonja = this.props.DatosUsuario.sister && this.props.DatosUsuario.type === "Monja";
    const conditionalRequieredSymbol = esMonja ? " *" : "";

    return (
      <>
        <Form className=" p-4" onSubmit={this.DatosPersonalesPut} id="MyForm" autoComplete="off">
          <Form.Group>
            <Form.Row>
              <small className="mb-3">
                Los campos con un <b>*</b> deben de ser rellenados.
              </small>
            </Form.Row>
            <Form.Label>Nombre *</Form.Label>
            <Form.Control required type="text" name="name" maxLength="45" autoComplete="nope" defaultValue={this.props.DatosUsuario.name} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Primer Apellido *</Form.Label>
            <Form.Control required type="text" name="firstSurname" maxLength="60" autoComplete="nope" defaultValue={this.props.DatosUsuario.firstSurname} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Segundo Apellido</Form.Label>
            <Form.Control type="text" name="secondSurname" maxLength="60" autoComplete="nope" defaultValue={this.props.DatosUsuario.secondSurname} />
          </Form.Group>
          {photo}
          <Form.Group>
            <Form.Label>Email </Form.Label>
            <Form.Control type="email" name="email" maxLength="320" autoComplete="nope" defaultValue={this.props.DatosUsuario.email} />
          </Form.Group>
          <Form.Group>
            <Form.Label>{`Fecha de Nacimiento `}</Form.Label>
            <Form.Control type="date" name="birthdate" max={today} autoComplete="nope" defaultValue={this.props.DatosUsuario.birthdate} />
          </Form.Group>
          <Form.Group>
            <Form.Label>{`Ciudad o localidad de Nacimiento `}</Form.Label>
            <Form.Control type="text" name="birthAddress" maxLength="100" autoComplete="nope" defaultValue={this.props.DatosUsuario.birthAddress} />
          </Form.Group>
          <Form.Group>
            <Form.Label>{`Provincia de Nacimiento `}</Form.Label>
            <Form.Control type="text" name="birthProvince" maxLength="45" autoComplete="nope" defaultValue={this.props.DatosUsuario.birthProvince} />
          </Form.Group>
          <Form.Group>
            <Form.Label>{`País de Nacimiento `}</Form.Label>
            <Form.Control type="text" name="birthCountry" maxLength="45" autoComplete="nope" defaultValue={this.props.DatosUsuario.birthCountry} />
          </Form.Group>
          <Form.Group>
            <Form.Label>{`Nacionalidad `} </Form.Label>
            <Form.Control type="text" name="nationality" maxLength="45" autoComplete="nope" defaultValue={this.props.DatosUsuario.nationality} />
          </Form.Group>
          <Form.Group>
            <Form.Label>{`Teléfono `}</Form.Label>
            <Form.Control type="text" name="telephone" maxLength="35" autoComplete="nope" defaultValue={this.props.DatosUsuario.telephone} />
          </Form.Group>
          <Form.Group>
            <Form.Label>{`Tipo de Documento de Identidad `}</Form.Label>
            <Form.Control as="select" name="documentType" defaultValue={this.props.DatosUsuario.documentType}>
              <option value="DNI" defaultValue>
                DNI/Carnet de identidad
              </option>
              <option value="NIE">NIE</option>
              <option value="Otro">Otro</option>
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>{`Doc. Identidad `}</Form.Label>
            <Form.Control type="text" name="documentId" maxLength="25" autoComplete="nope" defaultValue={this.props.DatosUsuario.documentId} />
          </Form.Group>
          {genderInput}
          {cv}
          {carnetConducir}
          <Desplegable
            Toogle={"Datos Pasaporte"}
            Text={
              <Col>
                <Form.Group>
                  <Form.Label>Número de pasaporte</Form.Label>
                  <Form.Control type="text" name="passport" maxLength="35" autoComplete="nope" defaultValue={this.props.DatosUsuario.passport} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Emitido por</Form.Label>
                  <Form.Control type="text" name="passportIssued" maxLength="45" autoComplete="nope" defaultValue={this.props.DatosUsuario.passportIssued} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Lugar de emisión</Form.Label>
                  <Form.Control type="text" name="passportPlace" maxLength="35" autoComplete="nope" defaultValue={this.props.DatosUsuario.passportPlace} />
                </Form.Group>
                <Form.Row>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Fecha Emisión</Form.Label>
                    <Form.Control id="30" type="date" name="issuedDate" max={today} autoComplete="nope" defaultValue={this.props.DatosUsuario.issuedDate} />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Fecha Expiración</Form.Label>
                    <Form.Control id="31" type="date" name="expiryDate" autoComplete="nope" defaultValue={this.props.DatosUsuario.expiryDate} />
                  </Form.Group>
                </Form.Row>
                {passport}
              </Col>
            }

          />
          {this.props.DatosUsuario.type === 'Laico' &&
            <>
              <input type="hidden" name="laico" value="1"></input>
              <Form.Group className="mt-3">
                <label>
                  <input type="checkbox" checked={this.state.active} name="active" onChange={() => this.changeActive()} /> Cese en la Congregación
                </label>
                { }
              </Form.Group>
            </>
          }
          {this.props.DatosUsuario.type === 'Laico' && this.state.active && <Form.Group>
            <Form.Label>{`Fecha de Cese`}</Form.Label>
            <Form.Control type="date" name="ceseLaico" max={today} autoComplete="nope" defaultValue={this.props.DatosUsuario.ceseLaico} required />
          </Form.Group>
          }

          <Form.Group>
            <Button type="submit" variant="outline-success" className="btn btn-block mt-5" name="Datos Personales">
              Guardar
            </Button>
          </Form.Group>

        </Form>


        {
          //console.log(this.props.DatosUsuario)
        }
      </>
    );
  }
}
